export const types = {
  FETCH_SIGNALS_REQUEST: 'developer-client/signals/FETCH_SIGNALS',
  FETCH_SIGNALS_SUCCESS: 'developer-client/signals/FETCH_SIGNALS_SUCCESS',
  FETCH_SIGNALS_FAILURE: 'developer-client/signals/FETCH_SIGNALS_FAILURE',
};

export const actions = {
  fetchSignalsRequest: () => ({
    type: types.FETCH_SIGNALS_REQUEST,
  }),
  fetchSignalsSuccess: data => ({
    type: types.FETCH_SIGNALS_SUCCESS,
    payload: data,
  }),
  fetchSignalsFailure: error => ({
    type: types.FETCH_SIGNALS_FAILURE,
    payload: error,
  }),
};

export const initialState = {
  signals: {
    signalsByGroup: {},
    totalSignalRecords: 0,
  },

  // loading states
  isFetchingSignals: false,

  // error states
  errorFetchingSignals: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SIGNALS_REQUEST:
      return {
        ...state,
        isFetchingSignals: true,
        errorFetchingSignals: false,
      };
    case types.FETCH_SIGNALS_SUCCESS:
      return {
        ...state,
        isFetchingSignals: false,
        signals: {
          signalsByGroup: action.payload.signalsByGroup,
          totalSignalRecords: action.payload.totalRecords,
        },
      };
    case types.FETCH_SIGNALS_FAILURE:
      return {
        ...state,
        isFetchingSignals: false,
        errorFetchingSignals: true,
      };
    default:
      return state;
  }
}
